import SteppedCheckoutSkeleton from './SteppedCheckoutSkeleton';

export default SteppedCheckoutSkeleton;
